__turbopack_context__.v({
  "contact": "ContactCta-module-scss-module__ThFnHW__contact",
  "content": "ContactCta-module-scss-module__ThFnHW__content",
  "posttext": "ContactCta-module-scss-module__ThFnHW__posttext",
  "thumbnail": "ContactCta-module-scss-module__ThFnHW__thumbnail",
  "with-links": "ContactCta-module-scss-module__ThFnHW__with-links",
});
